module.exports = __webpack_public_path__ + "static/media/new_pack_dog_super_EN_285x350.83037ecd.png";